import { TransactionForm } from "../transactionform.model";

export class BankWithdrawalForm extends TransactionForm {
  constructor(customerProducts, paymentOptions) {
    super(customerProducts, paymentOptions);

    this.bankPaymentOptions = [];
    this.bankPaymentOption = null;
    this.bankDetails = {};
    this.setAsDefault = false;
    this.confirmed = false;
  }

  toPayload() {
    let payload = {
      transaction: {
        transactionPassword: this.transactionPassword,
      }
    };

    payload['transaction']['paymentOption'] = this.bankPaymentOption;
    payload['transaction']['paymentOptionType'] = this.paymentOptionType;
    payload['transaction']['customerFee'] = this.fee;
    payload['transaction']['defaultBank'] = this.setAsDefault;

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
      subTransactions[subTransaction.key] = {
        product: subTransaction.product,
        amount: subTransaction.amount,
        forFee: subTransaction.forFee
      };
    }

    payload['transaction']['subTransactions'] = subTransactions;

    return payload;
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/bank/bank-withdrawal-form.model.js